export class SubscriptionHistory {
    id: number;
    log_date: Date;
    offer_code: string;
    status: string;
    subscription_id: number;
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/subscription-history.entity.ts